module.exports = __webpack_public_path__ + "static/media/anc4ru.ed4b3434.pdf";